import Component from './I18nMessage';
import I18nService from '../../../services/I18nService';

import { connect } from 'react-redux';

// on map le state de redux sur les props du composant
const mapStateToProps = (state, props) => {
  // const {globalKey,flow} = state.app;
  const labelKey = props.labelKey;

  // i18n service
  const myI18nService = I18nService.getInstance();
  const hasLabel = myI18nService.exists(labelKey);

  // if (DebugService.getInstance().enabled) console.log('Intro - ',{hasLabel,label: myI18nService.t(labelKey)});

  return {
    hasLabel,
    label: hasLabel ? myI18nService.t(labelKey) : undefined,
  };
};

export default connect(mapStateToProps, undefined)(Component);
